import React from 'react';
import Skeleton from 'react-loading-skeleton';

/**
 * Skeleton loader for Event Card
 * Matches event cards layout in events/page.tsx
 */
export const EventCardSkeleton: React.FC = () => {
  return (
    <div className="card elev-sm" style={{ padding: 0, overflow: 'hidden' }}>
      <div className="relative" style={{ aspectRatio: '16 / 10' }}>
        <Skeleton height="100%" style={{ position: 'absolute', inset: 0 }} />
      </div>

      <div style={{ padding: 'var(--space-4)' }}>
        <Skeleton height={18} width="80%" style={{ marginBottom: 'var(--space-2)' }} />

        <div className="flex flex-col gap-1" style={{ marginBottom: 'var(--space-2)' }}>
          <Skeleton width="60%" height={14} />
          <Skeleton width="50%" height={14} />
        </div>

        <Skeleton count={2} style={{ marginBottom: 'var(--space-3)' }} />

        <div
          className="flex items-center justify-between"
          style={{ paddingTop: 'var(--space-2)', borderTop: '1px solid var(--color-divider)' }}
        >
          <Skeleton width={40} height={16} />
          <Skeleton width={70} height={16} />
        </div>
      </div>
    </div>
  );
};

export default EventCardSkeleton;
